import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {ApiService} from './api.service';
import {CrudUtilities} from '../util/crud-utilities';
import {map} from 'rxjs/operators';
import {MarketingItemModel} from '../models/marketing-item.model';
import {MarketingItemsModel} from '../models/marketing-items.model';

@Injectable({
  providedIn: 'root'
})
export class MarketingItemService {


  public marketingItemsSubject = new BehaviorSubject<MarketingItemsModel>(new MarketingItemsModel());
  public marketingItems = this.marketingItemsSubject.asObservable();

  public selectedMarketingItemSubject = new BehaviorSubject<MarketingItemModel>(new MarketingItemModel());
  public selectedMarketingItem = this.selectedMarketingItemSubject.asObservable();


  constructor(private apiService: ApiService, public crudUtils: CrudUtilities) {

  }

  setMarketingItemItems(marketingItemItems: MarketingItemsModel) {
    this.marketingItemsSubject.next(marketingItemItems);
  }

  createMarketingItemItem(marketingItemItem: MarketingItemModel) {
    return this.apiService.post('marketingItems.json', marketingItemItem).subscribe((response) => {

      if (response.name) {
        marketingItemItem.id = response.name;
        this.selectedMarketingItemSubject.next({...marketingItemItem});
        this.crudUtils.addNewItemToList(this.marketingItemsSubject, marketingItemItem);
      }
    });
  }

  editMarketingItemItem(marketingItemItem: MarketingItemModel) {
    return this.apiService
      .patch(`marketingItems/${marketingItemItem.id}.json`, marketingItemItem).subscribe((response) => {
        this.selectedMarketingItemSubject.next({...response});
        this.crudUtils.editListItem(this.marketingItemsSubject, response);
      });
  }

  deleteMarketingItemItem(marketingItemItem, dialogRef) {
    return this.apiService.delete(`marketingItems/${marketingItemItem.id}.json`).subscribe(() => {
      this.crudUtils.deleteListItem(this.marketingItemsSubject, marketingItemItem);
      dialogRef.close();

    });
  }

  getMarketingItemItems() {
    return this.apiService.get('marketingItems.json').pipe(map((response) => {

      const list = [];
      for(const key in response) {
        response[key].id = key;
        list.push(response[key]);
      }
      return list;
    }));
  }

}
